import { proxy } from "valtio";

export const businessFibiClientStore = proxy<{
  fibiClientToken: string | undefined;
  storedCurrentSessionStartTime: number | undefined;
}>({
  fibiClientToken: undefined,
  storedCurrentSessionStartTime: undefined,
});
